// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"189":"editor","328":"admin","340":"overview","747":"wiki","985":"email_verified"}[chunkId] || chunkId) + "-legacy." + {"88":"14601e00","189":"5f868a3e","208":"14072d8a","328":"8aed0e7a","340":"6dc164fb","602":"eef13dd6","747":"03fdfdfb","887":"87cda129","985":"5b218f72","992":"26079084"}[chunkId] + ".js";
};